 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		12: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"0656f1d5a51d9af4522f4493de6807da0bd95040","3":"875ea9739805bb53fa356a6c6aa8caa3ccd69097","4":"2b607f61fb466bdca4b31f7ec2f285b1417f3fb9","5":"536944b53b6c17f37f8af04243e74184c4aa845d","6":"d57276643d07fc8bb9202edb1957f3f154a012e9","7":"5e1085ff354e3bb6daefedf5e48fe6e4b1d8e564","8":"0cc20c5e5e5f1913c7b3dee64f6a383ed3d42411","9":"771d6599373c657452cbf1b4a7e550360826e426","10":"8e5974099a4f8437c03b235ee630755b4020c76c","11":"f9699d5023c242c0625cc561044313e382157c2e","13":"06f6b0c0","15":"c2ef2995","16":"component---src-pages-404-js","17":"component---src-pages-cases-2-cents-js","18":"component---src-pages-cases-cartovera-js","19":"component---src-pages-cases-chernomorsk-js","20":"component---src-pages-cases-city-portal-js","21":"component---src-pages-cases-crm-sap-integration-js","22":"component---src-pages-cases-design-js","23":"component---src-pages-cases-diasoft-js","24":"component---src-pages-cases-fcteam-js","25":"component---src-pages-cases-gud-job-js","26":"component---src-pages-cases-ilich-realty-js","27":"component---src-pages-cases-ingo-js","28":"component---src-pages-cases-iot-js","29":"component---src-pages-cases-js","30":"component---src-pages-cases-karpatska-chaika-js","31":"component---src-pages-cases-pickup-sport-js","32":"component---src-pages-cases-rzd-roads-js","33":"component---src-pages-cases-service-doc-js","34":"component---src-pages-cases-social-app-js","35":"component---src-pages-cases-utility-management-software-js","36":"component---src-pages-cases-video-conference-js","37":"component---src-pages-cases-videoconftool-js","38":"component---src-pages-cases-webrtc-js","39":"component---src-pages-cases-wikigrads-js","40":"component---src-pages-company-js","41":"component---src-pages-contact-js","42":"component---src-pages-estimate-js","43":"component---src-pages-expertise-cloud-solutions-js","44":"component---src-pages-expertise-cross-platform-js","45":"component---src-pages-expertise-internet-of-things-js","46":"component---src-pages-expertise-js","47":"component---src-pages-expertise-medical-app-development-services-js","48":"component---src-pages-expertise-rtc-js","49":"component---src-pages-expertise-startup-development-js","50":"component---src-pages-expertise-uiuxdesign-js","51":"component---src-pages-how-we-work-js","52":"component---src-pages-index-js","53":"component---src-pages-services-dedicatedteam-js","54":"component---src-pages-services-js","55":"component---src-pages-services-mobile-js","56":"component---src-pages-services-qa-js","57":"component---src-pages-services-startups-js","58":"component---src-pages-services-uiuxdesign-js","59":"component---src-pages-services-web-js","60":"component---src-pages-technology-aws-js","61":"component---src-pages-technology-iot-js","62":"component---src-pages-technology-js","63":"e8433949"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"31a7e19a0d1389d91bc0","2":"255770167ac35df8f2a4","3":"8acc5bc049f7e47d3a59","4":"97399f82fc6132b0dc20","5":"5bc1dadb4498e674c642","6":"f0d83251b22c3dc243b0","7":"9ecc17a7eeb8809fbec4","8":"aa999acf640884af0fbe","9":"a6782abce38adf030bcd","10":"e809142fdbd25f702c70","11":"e12f6954ce8ef0c688c0","13":"4b72bec20eaf726c8ef7","15":"fcd3877e92ff23e00b30","16":"28f4fca4408396dde784","17":"f9f68b45dc179de169ab","18":"713f035373da97fb2f1c","19":"960302b9241463843b0b","20":"6c56a718764575d2dd69","21":"d1688706fd582c5cdd25","22":"c481385ae12f64e235f2","23":"51af99e9000bb5d6f273","24":"cd6eb99d2d2b2998c9f0","25":"71fe857b6bfbb5ae3719","26":"15a8e2fafa5f0bd3c3fc","27":"a7e046866586391e539e","28":"648fa28abad34e526060","29":"dd2c55e0c202fbe76754","30":"3081171c1ec9259582f7","31":"c27e4e312099da0d1d4e","32":"8b2f87145ef70399bb57","33":"5f65d776d94cc7dbce26","34":"d6e1497f7f678c795ed0","35":"fdbee3bdafe685f63403","36":"aa279cb8a466a8f18bcb","37":"0a5517f85c35ba3138a4","38":"49c022ad8c7e713368e4","39":"449e943faa6d143b26f0","40":"8087e9efb5ad03af1035","41":"992fdf7702942eebf84f","42":"4d4955ea42b009b4550b","43":"8392e1ae4515d91b6e85","44":"192e4a90ec1173f5efe8","45":"684c84326b320f5acf75","46":"ca11cb1856643f53c51b","47":"024b5b8fbb03f487ee4d","48":"03bce7fe300c50b20472","49":"ef0e3e54afa63edd71c1","50":"405684196e04712ee6e6","51":"24e9a06af163e416ef79","52":"4e948e5bafda3f90c2ec","53":"5c3cf2557e3df711b995","54":"54de73915f32d841ea71","55":"3b82402d3eb7d3d08a4e","56":"11da475c657e64b9fc7c","57":"66532dd5da68f824a54e","58":"eb814d0716239a9424d3","59":"de47edaf9a36fccc041f","60":"4266a788b93372933abc","61":"cc906763043bd4a4e00b","62":"e6625bc2cd9545de506b","63":"85b93221f15dc73727b3","66":"87e66f8b8423a3bbcac9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"0656f1d5a51d9af4522f4493de6807da0bd95040","3":"875ea9739805bb53fa356a6c6aa8caa3ccd69097","4":"2b607f61fb466bdca4b31f7ec2f285b1417f3fb9","5":"536944b53b6c17f37f8af04243e74184c4aa845d","6":"d57276643d07fc8bb9202edb1957f3f154a012e9","7":"5e1085ff354e3bb6daefedf5e48fe6e4b1d8e564","8":"0cc20c5e5e5f1913c7b3dee64f6a383ed3d42411","9":"771d6599373c657452cbf1b4a7e550360826e426","10":"8e5974099a4f8437c03b235ee630755b4020c76c","11":"f9699d5023c242c0625cc561044313e382157c2e","13":"06f6b0c0","15":"c2ef2995","16":"component---src-pages-404-js","17":"component---src-pages-cases-2-cents-js","18":"component---src-pages-cases-cartovera-js","19":"component---src-pages-cases-chernomorsk-js","20":"component---src-pages-cases-city-portal-js","21":"component---src-pages-cases-crm-sap-integration-js","22":"component---src-pages-cases-design-js","23":"component---src-pages-cases-diasoft-js","24":"component---src-pages-cases-fcteam-js","25":"component---src-pages-cases-gud-job-js","26":"component---src-pages-cases-ilich-realty-js","27":"component---src-pages-cases-ingo-js","28":"component---src-pages-cases-iot-js","29":"component---src-pages-cases-js","30":"component---src-pages-cases-karpatska-chaika-js","31":"component---src-pages-cases-pickup-sport-js","32":"component---src-pages-cases-rzd-roads-js","33":"component---src-pages-cases-service-doc-js","34":"component---src-pages-cases-social-app-js","35":"component---src-pages-cases-utility-management-software-js","36":"component---src-pages-cases-video-conference-js","37":"component---src-pages-cases-videoconftool-js","38":"component---src-pages-cases-webrtc-js","39":"component---src-pages-cases-wikigrads-js","40":"component---src-pages-company-js","41":"component---src-pages-contact-js","42":"component---src-pages-estimate-js","43":"component---src-pages-expertise-cloud-solutions-js","44":"component---src-pages-expertise-cross-platform-js","45":"component---src-pages-expertise-internet-of-things-js","46":"component---src-pages-expertise-js","47":"component---src-pages-expertise-medical-app-development-services-js","48":"component---src-pages-expertise-rtc-js","49":"component---src-pages-expertise-startup-development-js","50":"component---src-pages-expertise-uiuxdesign-js","51":"component---src-pages-how-we-work-js","52":"component---src-pages-index-js","53":"component---src-pages-services-dedicatedteam-js","54":"component---src-pages-services-js","55":"component---src-pages-services-mobile-js","56":"component---src-pages-services-qa-js","57":"component---src-pages-services-startups-js","58":"component---src-pages-services-uiuxdesign-js","59":"component---src-pages-services-web-js","60":"component---src-pages-technology-aws-js","61":"component---src-pages-technology-iot-js","62":"component---src-pages-technology-js","63":"e8433949"}[chunkId]||chunkId) + "." + {"0":"8957397efea1d1d27b3a","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
